import { post } from '@/utils/request'
// 发送邮件
export const sendMail = (data) => {
    return post(`/supplier/settle/sendSettleDetailListMail`, data)
}
